// extracted by mini-css-extract-plugin
export default {"Overlay":"P10HCWKRULtG3oKBhGvG","Container":"Zi9jt1vOcQgXPw_KWrpX","Header":"AsSnW3M7Vby69gjbFV8A","Close":"tRRDfvjgIfrj9uMcot6E","Content":"h3JrGC99N_JJifTxLTjL"};